import React from 'react';
import { CheckCircle2, Target, Eye, Award, Download } from 'lucide-react';
import { Button } from './ui/button';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const About = () => {
  const handleDownloadProfile = () => {
    window.open(`${BACKEND_URL}/api/company-profile/download`, '_blank');
  };

  const values = [
    {
      icon: <Target className="text-primary" size={32} />,
      title: "Quality Excellence",
      description: "We maintain the highest standards in every project, ensuring superior craftsmanship and durable results."
    },
    {
      icon: <CheckCircle2 className="text-primary" size={32} />,
      title: "Timely Delivery",
      description: "Our efficient project management ensures on-time completion without compromising on quality."
    },
    {
      icon: <Eye className="text-primary" size={32} />,
      title: "Transparency",
      description: "Clear communication and honest dealings form the foundation of our client relationships."
    },
    {
      icon: <Award className="text-primary" size={32} />,
      title: "Innovation",
      description: "We embrace modern construction technologies and sustainable building practices."
    }
  ];

  return (
    <section id="about" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div>
            <div className="inline-block mb-4">
              <span className="text-primary font-semibold text-sm tracking-wider uppercase">About Us</span>
            </div>
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
              Building Excellence Since 2008
            </h2>
            <p className="text-gray-600 text-lg mb-6 leading-relaxed">
              Florentina Infra LLP has established itself as a leading construction company in Ahmedabad and across Gujarat. 
              With over 15 years of experience, we have successfully delivered more than 250 projects ranging from luxury 
              residential complexes to large-scale commercial and infrastructure developments.
            </p>
            <p className="text-gray-600 text-lg mb-8 leading-relaxed">
              Our commitment to quality, innovation, and customer satisfaction has earned us the trust of hundreds of clients 
              and numerous industry awards. We combine traditional craftsmanship with modern construction techniques to 
              deliver exceptional results that stand the test of time.
            </p>

            {/* Mission & Vision */}
            <div className="bg-gray-50 p-6 rounded-lg border-l-4 border-primary mb-8">
              <h3 className="text-xl font-bold text-gray-900 mb-3">Our Mission</h3>
              <p className="text-gray-600 leading-relaxed">
                To build world-class infrastructure that enhances the quality of life while maintaining environmental 
                sustainability and delivering exceptional value to our clients.
              </p>
            </div>

            <div className="flex items-center gap-8 mb-8">
              <div>
                <div className="text-4xl font-bold text-primary">15+</div>
                <div className="text-gray-600 text-sm">Years Experience</div>
              </div>
              <div>
                <div className="text-4xl font-bold text-primary">250+</div>
                <div className="text-gray-600 text-sm">Projects Completed</div>
              </div>
              <div>
                <div className="text-4xl font-bold text-primary">500+</div>
                <div className="text-gray-600 text-sm">Happy Clients</div>
              </div>
            </div>

            <Button 
              onClick={handleDownloadProfile}
              className="bg-primary hover:bg-primary/90 text-white"
            >
              <Download className="mr-2" size={18} />
              Download Company Profile
            </Button>
          </div>

          {/* Right Content - Values Grid */}
          <div>
            <div className="grid sm:grid-cols-2 gap-6">
              {values.map((value, index) => (
                <div 
                  key={`value-${value.title}-${index}`}
                  className="bg-white p-6 rounded-lg border border-gray-200 hover:border-primary hover:shadow-lg transition-all duration-300"
                >
                  <div className="mb-4">
                    {value.icon}
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-3">
                    {value.title}
                  </h3>
                  <p className="text-gray-600 leading-relaxed">
                    {value.description}
                  </p>
                </div>
              ))}
            </div>

            {/* Image */}
            <div className="mt-6 rounded-lg overflow-hidden shadow-xl">
              <img
                src="https://images.unsplash.com/photo-1723367194881-fe2e53534170"
                alt="Construction Site"
                className="w-full h-64 object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
